import React, { useCallback, useEffect, useState } from "react";
import { injectIntl } from "react-intl";

import { useDoActions } from "../../../Base/Hooks/doActions";
import { getEventTimeForUpdatedDeletedEvents, sendEvent } from "../../../Base/Utilities/SendEvent";

const stashPopAction = {
  actions: [{ action: "popStash", type: "main" }],
  conditions: [],
};

const Cancel = (props) => {
  const { updateState, intl, panel, events } = props;
  const { formatMessage } = intl;
  const [doAction, setDoAction] = useState(false);
  const cancelActions = [...(panel.cancelActions ? panel.cancelActions : []), stashPopAction];
  const [actionsDone] = useDoActions(panel, props, doAction, cancelActions);

  const getPanelStateLevels = () => {
    let levels = new Set();
    panel.showOn.forEach(({ state }) => {
      if (["primary", "secondary"].includes(state)) {
        levels.add(state);
      }
    });
    return levels;
  };

  const _deleteEvent = (event) => {
    event.status = "deleted";
    event.eventTime = getEventTimeForUpdatedDeletedEvents(event);

    let action = {
      action: "sendEvent",
      event: event,
      type: "custom",
    };

    sendEvent(action, props);
  }

  useEffect(() => {
    if (actionsDone) {
      setDoAction(false);
    }
    // eslint-disable-next-line
  }, [actionsDone]);

  const doCancel = useCallback(() => {
    const deletedEventIds = new Set();
    const deleteEventOnce = (event) => {
      if (!event?.eventType) {
        return;
      }

      if (event.eventId) {
        if (deletedEventIds.has(event.eventId)) {
          return;
        }
        deletedEventIds.add(event.eventId);
      }

      _deleteEvent(event);
    };

    if (panel.allowCancelEvent) {
      const originalEvent = events[panel.allowCancelEvent];
      let cancelEvent = JSON.parse(JSON.stringify(originalEvent));

      deleteEventOnce(cancelEvent);
    }

    if (panel.allowCancelPlay) {
      props.eventStore
      .filter(event => event.playId === props.currentState.playId)
      .forEach(event => deleteEventOnce(event));
    }

    setDoAction(true);
    getPanelStateLevels().forEach((level) => {
      updateState(level, null);
    });
    updateState("editState", null);
    if (panel.doFullCancel) {
      updateState("modify", null);
    }

    updateState("backStatus", null);

  }, [updateState, panel, events, props]);

  const onKeyDown = useCallback(
    (event) => {
      if (event.code === "Escape") {
        doCancel();
      }
    },
    [doCancel],
  );

  useEffect(() => {
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onKeyDown]);

  return (
    <div className="cancel" onClick={doCancel}>
      <span>
        {formatMessage({
          id: "cancel",
          defaultMessage: "cancel",
        })}
      </span>
      <i className="fas fa-times"></i>
    </div>
  );
};

export default injectIntl(Cancel);
